import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { JobMatchCompareModalComponent } from 'src/app/pages/mission-control-page/add-candidates-page/job-match-compare-modal/job-match-compare-modal.component';
import { JobMatchActionsModalComponent } from 'src/app/core/services/job-match-actions-modal/job-match-actions-modal.component';
import { AssessmentService } from './assessment.service';
import { AlertAndNotificationsService } from './alert-and-notifications.service';
import * as _ from 'lodash';

declare var bootbox: any;

@Injectable({
  providedIn: 'root'
})
export class JobMatchActionsService {

  constructor(
    private assessmentService: AssessmentService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private bsModalService: BsModalService
  ) { }

  getReport(jobMatchId, assessmentType, isSectionalReport, reportUrl, testInvitationId, context?) {
    if(context == 'job-candidates-compare'){
        $(".modal").addClass("job-candidates-compare-modal-extra-large");
    }
    const config = new ModalConfig();
    config.class = this._withModalWidthClass('four-dot-five-modal-large');
    config.initialState = {
      type: 'report',
      title: assessmentType == 'Value' ? 'Value Assessment Report' : 'Technical Assessment Report',
      jobMatchId: jobMatchId,
      assessmentType: assessmentType,
      isSectionalReport: isSectionalReport,
      testInvitationId: testInvitationId,
      context: 'candidateJobMatchCard'
    };
    const modalRef = this.bsModalService.show(JobMatchActionsModalComponent, config);
    modalRef.content.onClose.subscribe(() => {
        if(context == 'job-candidates-compare'){
            setTimeout(() => {
                $(".modal").removeClass("job-candidates-compare-modal-extra-large");
            }, 600);
        }
    });
  }

  openFeedbackModal(feedbackDetails) {
    $(".modal").addClass("job-candidates-compare-modal-extra-large");
    const config = new ModalConfig();
    config.class = this._withModalWidthClass('four-dot-five-modal-medium');
    config.initialState = {
      type: 'feedback',
      title: feedbackDetails.label,
      jobId: feedbackDetails.jobId,
      jobMatchId: feedbackDetails.jobMatchId,
      candidateId: feedbackDetails.candidateId,
      feedbackType: feedbackDetails.feedbackType, //Screening/PhoneScreen/Interview
      feedbackContext: feedbackDetails.context
    };
    const modalRef = this.bsModalService.show(JobMatchActionsModalComponent, config);
    modalRef.content.onClose.subscribe(() => {
        setTimeout(() => {
            $(".modal").removeClass("job-candidates-compare-modal-extra-large");
        }, 600);
    });
  }

  openImageProctoringInfoModal(activeViolation, techAssessmentReportInfoList) {
    let icon = '';
    if(activeViolation.type == 'Proctoring Issue') {
        icon = '<i class="fas fa-exclamation-triangle fa-lg text-warning"></i> ';
    } else if(activeViolation.type == 'Proctoring Violation') {
        icon = '<i class="fa fa-exclamation-circle fa-lg text-danger"></i> ';
    } else if(activeViolation.type == 'Information') {
        icon = '<i class="fa fa-info-circle fa-lg text-primary"></i> ';
    }
    const config = new ModalConfig();
    config.class = this._withModalWidthClass('four-dot-five-modal-medium');
    config.initialState = {
      type: 'imageProctoringInfo',
      title: icon + activeViolation.type,
      activeViolation: activeViolation,
      techAssessmentReportInfoList: techAssessmentReportInfoList
    };
    this.bsModalService.show(JobMatchActionsModalComponent, config);
  }

  openAssessmentInfoModal(jobMatchId, assessmentType) {
    const config = new ModalConfig();
    config.class = this._withModalWidthClass('four-dot-five-modal-extra-large');
    config.initialState = {
      type: 'assessmentInfo',
      title: assessmentType == 'Value Assessment' ? 'Value Assessment Info' : 'Technical Assessment Info',
      jobMatchId: jobMatchId,
      assessmentType: assessmentType
    };
    this.bsModalService.show(JobMatchActionsModalComponent, config);
  }

  openMeetingsModal(jobMatchId, meetingType, refreshCallback) {
    let title = 'Interviews';
    if(meetingType == 'PhoneScreen') {
        title = 'Phone Screens';
    } else if(meetingType == 'RecruiterScreening') {
        title = 'Recruiter Screenings';
    }
    const config = new ModalConfig();
    config.class = this._withModalWidthClass('four-dot-five-modal-large');
    config.initialState = {
      type: 'meetings',
      title: title,
      jobMatchId: jobMatchId,
      meetingType: meetingType
    };
    const modalRef = this.bsModalService.show(JobMatchActionsModalComponent, config);
    modalRef.content.onClose.subscribe((result) => {
        if(result) {
            refreshCallback();
        }
    });
  }

  showAllActivityModal(jobMatch, jobMatchId, activityMap) {
    const config = new ModalConfig();
    config.class = 'custom-modal-2xl custom-candidate-job-match-modal';
    config.initialState = {
      type: 'activities',
      title: 'Candidate Activity',
      candidateInfo: jobMatch,
      jobMatchId: jobMatchId,
      activityMap: activityMap
    };
    this.bsModalService.show(JobMatchActionsModalComponent, config);
  }

  performAction(context, actionObject, jobMatch, refreshCallback, removeOrRefreshCardCallback) {
    if (context === 'uploadResumes' && actionObject.actionType === 'CANDIDATE_JOB_COMPARE') {
      this._openJobMatchCompareModal(actionObject, jobMatch);
      return;
    }
    if(!actionObject.allowed) {
        var message = _.isNull(actionObject.message) ? 'This Action is not allowed.' : actionObject.message;
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Action Not Allowed!</strong></div>",
            message: message,
            className: "zIndex1060",
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            }
        });
    } else {
        let actionType = actionObject.actionType;
        let label = actionObject.action;
        switch(actionType) {
            case 'NOT_INTERESTED':
            case 'RELEASE':
            case 'DELETE_JOBMATCH':
                this._launchSetStatusModal(context, actionObject, label, jobMatch, refreshCallback, removeOrRefreshCardCallback);
                break;
            case 'START_SCREENING':
                // this._openConferenceScreen(context, actionType, label, jobMatch, refreshCallback, removeOrRefreshCardCallback);
                // break;
            case 'NOTES':
            case 'COMMUNICATION':
            case 'PEER_COMMUNICATION':
            case 'RECRUITER_SCREENING_FEEDBACK':
            case 'PHONE_SCREEN_FEEDBACK':
            case 'INTERVIEW_FEEDBACK':
            case 'RECRUITER_SCREENING_FEEDBACK_FROM_MEETING_POPUP':
            case 'PHONE_SCREEN_FEEDBACK_FROM_MEETING_POPUP':
            case 'INTERVIEW_FEEDBACK_FROM_MEETING_POPUP':
            case 'MOVE_BACKWARD':
            case 'MOVE_FORWARD':
            case 'ASSIGN_RECRUITER':
            case 'SEND_TECHNICAL_ASSESSMENT':
            case 'SEND_VALUE_ASSESSMENT':
            case 'RE_SEND_TECHNICAL_ASSESSMENT':
            case 'RE_SEND_VALUE_ASSESSMENT':
            case 'CANCEL_TECHNICAL_ASSESSMENT':
            case 'CANCEL_VALUE_ASSESSMENT':
            case 'SCHEDULE_RECRUITER_SCREENING':
            case 'MODIFY_RECRUITER_SCREENING':
            case 'CANCEL_RECRUITER_SCREENING':
            case 'SCHEDULE_PHONE_SCREEN':
            case 'MODIFY_PHONE_SCREEN':
            case 'SCHEDULE_INTERVIEW':
            case 'MODIFY_INTERVIEW':
            case 'CANCEL_PHONE_SCREEN':
            case 'CANCEL_INTERVIEW':
            case 'UPDATE_CONTACT':
            case 'CANDIDATE_JOB_COMPARE':
            case 'CANDIDATE_PROFILE':
            case 'SKIP_RECRUITER_SCREENING':
            case 'SKIP_TECHNICAL_ASSESSMENT':
            case 'SKIP_VALUE_ASSESSMENT':
            case 'SKIP_PHONE_SCREEN':
            case 'SKIP_INTERVIEW':
            case 'EXPORT_CANDIDATE_INFO':
            case 'UPLOAD_RESUME':
            case 'CANDIDATE_BOOKLET':
            case 'SEND_EMAIL':
            case 'CLIENT_REVIEW':
                this.setDataAndLaunchJobMatchIdModal(context, actionType, label, jobMatch, actionObject, refreshCallback, removeOrRefreshCardCallback);
                break;
            default:
            //do nothing
        }
    }
  }

  private _openJobMatchCompareModal(actionObject, jobMatch) {
    const config = new ModalConfig();
    config.class = this._withModalWidthClass('four-dot-five-modal-large');
    config.initialState = {
      label: actionObject.action,
      jobId: jobMatch.jobMatchJobId,
      candidateId: jobMatch.id,
      jobMatchId: jobMatch.jobMatchId
    };
    this.bsModalService.show(JobMatchCompareModalComponent, config);
  }

  _launchSetStatusModal(context, actionObject, modalType, jobMatch, refreshCallback, removeOrRefreshCardCallback) {
    let statusType = '';
    switch(modalType) {
        case 'Not Interested':
            statusType = 'Not Interested';
            break;
        case 'Release':
            statusType = 'Release';
            break;
        case 'Delete Job Match':
            statusType = 'Delete Job Match';
            break;
    }

    const jobMatchDetailsArray = [{
        jobMatchId: jobMatch.jobMatchId,
        candidateId: jobMatch.id,
        workflowStepName: jobMatch.currentStep
    }];

    const config = new ModalConfig();
    config.class = this._withModalWidthClass('four-dot-five-modal-large');
    config.initialState = {
      type: 'setStatus',
      title: statusType,
      jobMatchDetailsArray: jobMatchDetailsArray,
      statusType: statusType,
      formalizeActivityPayload: actionObject.formalizeActivityPayload
    };
    const modalRef = this.bsModalService.show(JobMatchActionsModalComponent, config);
    modalRef.content.onClose.subscribe((result) => {
        if(result) {
            if(statusType == 'Delete Job Match' && context == "candidateJobMatches") {
                removeOrRefreshCardCallback();
            } else {
                refreshCallback();
            }
        }
    });
  }

  setDataAndLaunchJobMatchIdModal(context, modalType, label, jobMatch, actionObject, refreshCallback, removeOrRefreshCardCallback) {
    let subType = '';
    let callbackType = '';
    let windowTopClass = 'four-dot-five-modal-medium';
    switch(modalType) {
        case 'NOTES':
            subType = 'notes';
            break;
        case 'COMMUNICATION':
            subType = 'communication';
            break;
        case 'PEER_COMMUNICATION':
            subType = 'communication';
            windowTopClass = 'four-dot-five-modal-extra-large';
            callbackType = 'refreshJobMatch';
            break;
        case 'ASSIGN_RECRUITER':
            subType = 'assignRecruiter';
            callbackType = 'refreshJobMatch';
            break;
        case 'START_SCREENING':
            subType = 'screening';
            callbackType = 'refreshWorkflow';
            windowTopClass = 'four-dot-five-modal-large';
            break;
        case 'RECRUITER_SCREENING_FEEDBACK':
        case 'PHONE_SCREEN_FEEDBACK':
        case 'INTERVIEW_FEEDBACK':
        case 'RECRUITER_SCREENING_FEEDBACK_FROM_MEETING_POPUP':
        case 'PHONE_SCREEN_FEEDBACK_FROM_MEETING_POPUP':
        case 'INTERVIEW_FEEDBACK_FROM_MEETING_POPUP':
            subType = 'screening';
            callbackType = 'refreshJobMatch';
            break;
        case 'MOVE_FORWARD':
        case 'MOVE_BACKWARD':
            subType = 'move';
            callbackType = 'refreshWorkflow';
            break;
        case 'SEND_TECHNICAL_ASSESSMENT':
        case 'SEND_VALUE_ASSESSMENT':
        case 'RE_SEND_TECHNICAL_ASSESSMENT':
        case 'RE_SEND_VALUE_ASSESSMENT':
            subType = 'sendAssessment';
            callbackType = 'refreshJobMatch';
            break;
        case 'CANCEL_TECHNICAL_ASSESSMENT':
        case 'CANCEL_VALUE_ASSESSMENT':
            subType = 'cancelAssessment';
            callbackType = 'refreshJobMatch';
            break;
        case 'SCHEDULE_RECRUITER_SCREENING':
        case 'MODIFY_RECRUITER_SCREENING':
        case 'SCHEDULE_PHONE_SCREEN':
        case 'MODIFY_PHONE_SCREEN':
        case 'SCHEDULE_INTERVIEW':
        case 'MODIFY_INTERVIEW':
            subType = 'schedule';
            callbackType = 'refreshJobMatch';
            break;
        case 'CANCEL_RECRUITER_SCREENING':
        case 'CANCEL_PHONE_SCREEN':
        case 'CANCEL_INTERVIEW':
            subType = 'cancelMeeting';
            callbackType = 'refreshJobMatch';
            break;
        case 'UPDATE_CONTACT':
            subType = 'updateContact';
            callbackType = 'refreshJobMatch';
            break;
        case 'CANDIDATE_JOB_COMPARE':
            subType = 'actions';
            windowTopClass = 'four-dot-five-modal-large';
            break;
        case 'CANDIDATE_PROFILE':
            subType = 'actions';
            windowTopClass = 'four-dot-five-modal-large';
            break;
        case 'CANDIDATE_BOOKLET':
            subType = 'actions';
            windowTopClass = 'four-dot-five-modal-large';
            break;
        case 'EXPORT_CANDIDATE_INFO':
            subType = 'actions';
            break;
        case 'SKIP_RECRUITER_SCREENING':
        case 'SKIP_TECHNICAL_ASSESSMENT':
        case 'SKIP_VALUE_ASSESSMENT':
        case 'SKIP_PHONE_SCREEN':
        case 'SKIP_INTERVIEW':
            subType = 'move';
            windowTopClass = 'four-dot-five-modal-small';
            callbackType = 'refreshWorkflow';
            break;
        case 'UPLOAD_RESUME':
            subType = 'uploadResume';
            windowTopClass = 'four-dot-five-modal-large';
            callbackType = 'refreshJobMatch';
            break;
        case 'SEND_EMAIL':
            subType = 'actions';
            windowTopClass = 'four-dot-five-modal-extra-large';
            callbackType = 'refreshJobMatch';
            break;
        case 'CLIENT_REVIEW':
            subType = 'actions';
            windowTopClass = 'four-dot-five-modal-large';
            callbackType = 'refreshJobMatch';
            break;
    }
    if(modalType == 'RE_SEND_TECHNICAL_ASSESSMENT' || modalType == 'RE_SEND_VALUE_ASSESSMENT') {
        this._setAssessmentDataAndLaunchModal(context, modalType, label, subType, windowTopClass, callbackType, jobMatch, refreshCallback, removeOrRefreshCardCallback, actionObject);
    } else {
        this.launchActionModal(context, jobMatch, modalType, label, subType, windowTopClass, actionObject, callbackType, refreshCallback, removeOrRefreshCardCallback);
    }
  }

  _setAssessmentDataAndLaunchModal(context, modalType, label, templateUrl, windowTopClass, callbackType, jobMatch, refreshCallback, removeOrRefreshCardCallback, actionObject) {
    let assessmentType = 'Technical';
    if(modalType == 'RE_SEND_VALUE_ASSESSMENT') {
        assessmentType = 'Value';
    }
    let assessmentDetailsObject: any = {};
    let assessmentDetails: any = {};
    assessmentDetailsObject.jobMatchId = jobMatch.jobMatchId;
    assessmentDetailsObject.assessmentType = assessmentType;
    this.assessmentService.getCandidateAssessmentDetails(assessmentDetailsObject, (data) => {
        assessmentDetails = data;
        assessmentDetails.isSendAssessmentFailed = jobMatch.jobMatchCurrentState.includes("Failed");
        if(!_.isNull(assessmentDetails.expiredDateTime)) {
            assessmentDetails.expiredDateTime = new Date(assessmentDetails.expiredDateTime);
        }
        if(!_.isNull(assessmentDetails.cancelledDateTime)) {
            assessmentDetails.cancelledDateTime = new Date(assessmentDetails.cancelledDateTime);
        }
        if(!_.isNull(assessmentDetails.completedDateTime)) {
            assessmentDetails.completedDateTime = new Date(assessmentDetails.completedDateTime);
        }
        if(!_.isNull(assessmentDetails.sentDateTime)) {
            assessmentDetails.sentDateTime = new Date(assessmentDetails.sentDateTime);
        }
        if(!_.isNull(assessmentDetails.suspendedDateTime)) {
            assessmentDetails.suspendedDateTime = new Date(assessmentDetails.suspendedDateTime);
        }
        if(!_.isNull(assessmentDetails.terminatedDateTime)) {
            assessmentDetails.terminatedDateTime = new Date(assessmentDetails.terminatedDateTime);
        }
        if(!_.isNull(assessmentDetails.testLeftDateTime)) {
            assessmentDetails.testLeftDateTime = new Date(assessmentDetails.testLeftDateTime);
        }
        if(!_.isNull(assessmentDetails.sentDateTime)) {
            assessmentDetails.sentDateTime = new Date(assessmentDetails.sentDateTime);
        }
        var previousStateDateTime: any = '';
        if(assessmentDetails.assessmentLinkStatus == 'Expired' && !_.isNull(assessmentDetails.expiredDateTime)) {
            previousStateDateTime = assessmentDetails.expiredDateTime;
        } else if(assessmentDetails.assessmentLinkStatus == 'Suspended' && !_.isNull(assessmentDetails.suspendedDateTime)) {
            previousStateDateTime = assessmentDetails.suspendedDateTime;
        } else if(assessmentDetails.assessmentLinkStatus == 'Terminated' && !_.isNull(assessmentDetails.terminatedDateTime)) {
            previousStateDateTime = assessmentDetails.terminatedDateTime;
        } else if(assessmentDetails.assessmentLinkStatus == 'Test Left' && !_.isNull(assessmentDetails.testLeftDateTime)) {
            previousStateDateTime = assessmentDetails.testLeftDateTime;
        } else if(assessmentDetails.assessmentLinkStatus == 'Complete' && !_.isNull(assessmentDetails.completedDateTime)) {
            previousStateDateTime = assessmentDetails.completedDateTime;
        } else {
            previousStateDateTime = assessmentDetails.sentDateTime;
        }
        assessmentDetails.sendAssessmentsCount = assessmentDetails.sendAssessmentsCount + 1;
        if(assessmentDetails.assessmentLinkStatus == 'Expired') {
            let notes = "";
            this.launchActionModal(context, jobMatch, modalType, label, templateUrl, windowTopClass, callbackType, refreshCallback, removeOrRefreshCardCallback, notes);
        } else {
            const config = new ModalConfig();
            config.class = this._withModalWidthClass('four-dot-five-modal-large');
            config.ignoreBackdropClick = true;
            config.keyboard = false;
            config.initialState = {
                type: 'confirmResendAssessment',
                title: 'Confirm Re-send',
                assessmentDetails: assessmentDetails,
                previousStateDateTime: previousStateDateTime,
                formalizeActivityPayload: actionObject.formalizeActivityPayload,
                resendCallback: (reason, otherReasonNotes) => {
                    if(!_.isUndefined(reason)) {
                        var notes = "";
                        if(reason != 'Other') {
                            notes = reason;
                        } else if(!_.isUndefined(otherReasonNotes)) {
                            notes = otherReasonNotes;
                        }
                        this.launchActionModal(context, jobMatch, modalType, label, templateUrl, windowTopClass, callbackType, refreshCallback, removeOrRefreshCardCallback, notes);
                    }
                }
            };
            this.bsModalService.show(JobMatchActionsModalComponent, config);
        }
    }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  // ngx-bootstrap puts config.class on .modal-dialog, but the four-dot-five-modal-* width rules target its parent,
  // so the old window classes alone leave the dialog at the Bootstrap default width.
  _withModalWidthClass(windowTopClass: string): string {
    const widthClasses = {
      'four-dot-five-modal-small': 'custom-modal-50 custom-candidate-job-match-modal',
      'four-dot-five-modal-medium': 'custom-modal-65 custom-candidate-job-match-modal',
      'four-dot-five-modal-large': 'custom-modal-xl custom-candidate-job-match-modal',
      'four-dot-five-modal-extra-large': 'custom-modal-2xl custom-candidate-job-match-modal'
    };
    const widthClass = Object.keys(widthClasses).filter(key => windowTopClass.split(' ').includes(key)).map(key => widthClasses[key]);
    return [windowTopClass].concat(widthClass).join(' ');
  }

  launchActionModal(context, jobMatch, modalType, label, subType, windowTopClass, actionObject, callbackType, refreshCallback, removeOrRefreshCardCallback, notes?) {
    let workflowStep = "";
    if(modalType == 'PHONE_SCREEN_FEEDBACK' || jobMatch.currentStep == 'Phone Screen'){
        workflowStep = "ps";
    } else if(modalType == 'INTERVIEW_FEEDBACK' || jobMatch.currentStep == 'Interview'){
        workflowStep = "in";
    } else if(modalType == 'START_SCREENING' || modalType == 'RECRUITER_SCREENING_FEEDBACK' || modalType == 'RECRUITER_SCREENING_FEEDBACK_FROM_MEETING_POPUP' || modalType == 'SCHEDULE_RECRUITER_SCREENING' || modalType == 'MODIFY_RECRUITER_SCREENING' || modalType == 'CANCEL_RECRUITER_SCREENING'){
        workflowStep = "rs";
    }
    let isNestedOverExistingModal = context === "associateCandidates" || context === "reviewCandidatePull" || context === "uploadResumes";
    const isOverJobMatchesPopover = context === "candidateJobMatchesPopover";
    if(context === "associateCandidates") {
        $(".modal").addClass("associate-candidate-modal");
    } else if(context === "reviewCandidatePull" || context === "uploadResumes") {
        $(".modal").addClass("review-candidate-pull-modal");
    }
    if(isNestedOverExistingModal) {
        document.body.classList.add('nested-uib-modal-open');
        windowTopClass = windowTopClass ? windowTopClass + ' nested-uib-modal-window' : 'nested-uib-modal-window';
    }

    if(isOverJobMatchesPopover) {
        document.body.classList.add('job-match-popover-modal-open');
    }

    let moveType = 'Forward';
    if(modalType == 'MOVE_BACKWARD') {
        moveType = 'Backward';
    } else if(modalType == "SKIP_RECRUITER_SCREENING" || modalType == "SKIP_TECHNICAL_ASSESSMENT" || modalType == "SKIP_VALUE_ASSESSMENT" || modalType == "SKIP_PHONE_SCREEN" || modalType == "SKIP_INTERVIEW") {
        moveType = 'Skip';
    }
    let assessmentType = 'Technical';
    let assessmentSendMode = 'send';
    if(modalType == 'SEND_VALUE_ASSESSMENT' || modalType == 'CANCEL_VALUE_ASSESSMENT' || modalType == 'RE_SEND_VALUE_ASSESSMENT') {
        assessmentType = 'Value';
    }
    if(modalType == 'RE_SEND_TECHNICAL_ASSESSMENT' || modalType == 'RE_SEND_VALUE_ASSESSMENT') {
        assessmentSendMode = 'resend';
    }
    let scheduleType = 'phoneScreen';
    if(modalType == 'SCHEDULE_INTERVIEW' || modalType == 'MODIFY_INTERVIEW' || modalType == 'CANCEL_INTERVIEW') {
        scheduleType = 'interview';
    } else if(modalType == 'SCHEDULE_RECRUITER_SCREENING' || modalType == 'MODIFY_RECRUITER_SCREENING' || modalType == 'CANCEL_RECRUITER_SCREENING') {
        scheduleType = 'recruiterScreening';
    }
    let scheduleMode = 'add';
    if(modalType == 'MODIFY_PHONE_SCREEN' || modalType == 'MODIFY_INTERVIEW' || modalType == 'MODIFY_RECRUITER_SCREENING') {
        scheduleMode = 'edit';
    }
    let feedbackType = 'Screening';
    if(modalType == 'INTERVIEW_FEEDBACK' || modalType == 'INTERVIEW_FEEDBACK_FROM_MEETING_POPUP') {
        feedbackType = 'Interview';
    } else if(modalType == 'PHONE_SCREEN_FEEDBACK' || modalType == 'PHONE_SCREEN_FEEDBACK_FROM_MEETING_POPUP') {
        feedbackType = 'PhoneScreen';
    } else if(modalType == 'RECRUITER_SCREENING_FEEDBACK' || modalType == 'RECRUITER_SCREENING_FEEDBACK_FROM_MEETING_POPUP') {
        feedbackType = 'RecruiterScreening';
    }
    let communicationType;
    if(modalType == 'COMMUNICATION') {
        communicationType = 'candidate';
    } else if(modalType == 'PEER_COMMUNICATION') {
        communicationType = 'peer';
    }

    let title = label;
    if(subType == 'notes') {
        title = 'Notes';
    } else if(subType == 'communication') {
        title = (communicationType == 'peer' ? 'Peer' : 'Candidate') + ' Communication';
    }

    setTimeout(() => {
        const config = new ModalConfig();
        config.class = this._withModalWidthClass(windowTopClass);
        config.initialState = {
          type: 'jobMatchAction',
          subType: subType,
          modalType: modalType,
          label: label,
          title: title,
          context: context,
          callbackType: callbackType,
          refreshCallback: refreshCallback,
          removeOrRefreshCardCallback: removeOrRefreshCardCallback,
          jobMatchId: jobMatch.jobMatchId,
          jobId: jobMatch.jobMatchJobId,
          candidateId: jobMatch.id,
          candidateJobMatch: jobMatch,
          recruiterId: !_.isUndefined(jobMatch.primaryRecruiter) ? jobMatch.primaryRecruiter.id : undefined,
          isSharedRequisition: jobMatch.isSharedRequisition,
          corporateCompanyId: jobMatch.corporateCompanyId,
          corporateCompanyName: jobMatch.corporateCompanyName,
          clientOrBUName: jobMatch.clientOrBUName,
          jobMatchInfo: jobMatch,
          notes: notes,
          workflowStep: workflowStep,
          candidateDetails: actionObject.candidateDetails,
          clientReviewDetails: actionObject.clientReviewDetails,
          formalizeActivityPayload: actionObject.formalizeActivityPayload,
          moveType: moveType,
          assessmentType: assessmentType,
          assessmentSendMode: assessmentSendMode,
          scheduleType: scheduleType,
          scheduleMode: scheduleMode,
          feedbackType: feedbackType,
          communicationType: communicationType
        };
        const modalRef = this.bsModalService.show(JobMatchActionsModalComponent, config);
        if(isNestedOverExistingModal) {
            modalRef.content.onClose.subscribe(() => {
                document.body.classList.remove('nested-uib-modal-open');
            });
        }
        if(isOverJobMatchesPopover) {
            modalRef.content.onClose.subscribe(() => {
                document.body.classList.remove('job-match-popover-modal-open');
            });
        }
    }, 300);
  }

  openSendOutreachEmailModal(jobMatches, isVendorOnly, companyId, userId, candidateId, clientOrBUId, candidateType, salaryDurationOptions, jobTypeList, candidateName, successCallback) {
    const config = new ModalConfig();
    config.class = this._withModalWidthClass('four-dot-five-modal-large');
    config.initialState = {
      type: 'sendOutreachEmail',
      title: `Send Outreach to Candidate <b>'${candidateName}'</b>`,
      jobMatches: jobMatches,
      isVendorOnly: isVendorOnly,
      companyId: companyId,
      userId: userId,
      candidateId: candidateId,
      clientOrBUId: clientOrBUId,
      candidateType: candidateType,
      salaryDurationOptions: salaryDurationOptions,
      jobTypeList: jobTypeList
    };
    const modalRef = this.bsModalService.show(JobMatchActionsModalComponent, config);
    modalRef.content.onClose.subscribe((result) => {
        if (result) {
            successCallback();
        }
    });
  }

  _setCandidateInfoInEmailBody(candidate, candidateAdditionalDetails) {
    let candidateInformation = [];
    let candidateInformationList= ['Full Name', 'Phone Number', 'Email', 'Address', 'Current Role', 'Current Company', 'Seeking Job Type', 'Desired Salary/Rate', 'Sponsorship', 'Sponsorship Notes' , 'Preferred Work Locations', 'Willing To Relocate', 'Linkedin Url', 'Additional Information'];
    candidateInformationList.map(val => {
        let tempInformation: any = {};
            tempInformation.id = 'id' + val;
            tempInformation.name = val;
            tempInformation.value = this._setCandidateInformationObject(val, candidate, candidateAdditionalDetails);
        if(tempInformation.value && tempInformation.value != '') {
            candidateInformation.push(tempInformation);
        }
    });
    return candidateInformation;
  }

  _setCandidateInformationObject(val, candidate, candidateAdditionalDetails) {
    let candidateInformation;
    switch (val) {
        case 'Full Name':
            candidateInformation = (candidate.firstName ? (candidate.firstName + " ") : '') + (candidate.lastName ? candidate.lastName : '');
            break;
        case 'Phone Number':
            candidateInformation = candidate.mobilephone;
            break;
        case 'Email':
            candidateInformation = candidate.email;
            break;
        case 'Address':
            let address = '';
            if(candidate.address) {
                address = address + (candidate.address.address1 ? candidate.address.address1 + ',' : '');
                address = address + (candidate.address.address2 ? candidate.address.address2 + ',' : '');
                address = address + (candidate.address.state ? candidate.address.state + ',' : '');
                address = address + (candidate.address.city ? candidate.address.city.name + ',' : '');
                address = address + (candidate.address.country ? candidate.address.country + ',' : '');
                address = address + (candidate.address.zipcode ? candidate.address.zipcode : '');
            }
            candidateInformation = address;
            break;
        // case 'Current Location':
        //     candidateInformation = candidate.currentJobLocation;
            break;
        case 'Current Role':
            candidateInformation = candidate.currentJobTitle;
            break;
        case 'Current Company':
            candidateInformation = candidate.currentJobCompanyName;
            break;
        case 'Seeking Job Type':
            let matchedJobType = '';
            if(candidateAdditionalDetails && candidateAdditionalDetails.requisitionJobType) {
                if(candidateAdditionalDetails.preferredJobTypeDetails && candidateAdditionalDetails.preferredJobTypeDetails.jobType) {
                    candidateAdditionalDetails.preferredJobTypeDetails.jobType.map(jobType => {
                        if(jobType.jobType == candidateAdditionalDetails.requisitionJobType) {
                            matchedJobType = jobType.jobType;
                        }
                    });
                }
            }
            candidateInformation = matchedJobType;
            break;
        case 'Desired Salary/Rate':
            let salaryOrRate = '';
            if (candidateAdditionalDetails && candidateAdditionalDetails.preferredJobTypeDetails) {
                if (candidateAdditionalDetails.requisitionJobType) {
                    if (candidateAdditionalDetails.requisitionJobType === 'FULLTIME' && candidateAdditionalDetails.preferredJobTypeDetails.salary) {
                        salaryOrRate = salaryOrRate + 'Salary: ' + this._setCandidateSalaryOrRate('salary', candidateAdditionalDetails.preferredJobTypeDetails.salary);
                    } else {
                        if (candidateAdditionalDetails.preferredJobTypeDetails.rate) {
                            salaryOrRate = salaryOrRate + 'Rate: ' + this._setCandidateSalaryOrRate('rate', candidateAdditionalDetails.preferredJobTypeDetails.rate);
                        }
                    }
                } else {
                    if (candidateAdditionalDetails.preferredJobTypeDetails.salary) {
                        salaryOrRate = salaryOrRate + 'Salary: ' + this._setCandidateSalaryOrRate('salary', candidateAdditionalDetails.preferredJobTypeDetails.salary);
                    }

                    if (candidateAdditionalDetails.preferredJobTypeDetails.rate) {
                        salaryOrRate = (salaryOrRate != '' ? salaryOrRate + '; ' : salaryOrRate) + 'Rate: ' + this._setCandidateSalaryOrRate('rate', candidateAdditionalDetails.preferredJobTypeDetails.rate);
                    }
                }
            }
            candidateInformation = salaryOrRate;
            break;
        case 'Sponsorship':
            candidateInformation = (candidateAdditionalDetails && candidateAdditionalDetails.sponsorships) ? candidateAdditionalDetails.sponsorships.toString() : '';
            break;
        case 'Sponsorship Notes':
            candidateInformation = candidateAdditionalDetails ? candidateAdditionalDetails.sponsorshipsNote : '';
            break;
        case 'Preferred Work Locations':
            candidateInformation = (candidateAdditionalDetails && candidateAdditionalDetails.preferredWorkLocations) ? candidateAdditionalDetails.preferredWorkLocations
                .map(location => location.name)
                .join(', ') : '';
            break;
        case 'Willing To Relocate':
            candidateInformation = candidateAdditionalDetails ? candidateAdditionalDetails.willingToRelocate : '';
            break;
        case 'Linkedin Url':
            let linkedinUrl = '';
            if(candidateAdditionalDetails && candidateAdditionalDetails.urls) {
                candidateAdditionalDetails.urls.map(url => {
                    if(url.urlType == 'LinkedIn') {
                        linkedinUrl = url.urlLink;
                    }
                });
            }
            candidateInformation = linkedinUrl;
            break;
        case 'Additional Information':
            candidateInformation = candidateAdditionalDetails ? candidateAdditionalDetails.additionalInformation : '';
            break;
        default:
            break;
    }

    // If value is null, undefined, or empty string, assign 'Not Specified'
    if (!candidateInformation || candidateInformation === '') {
        candidateInformation = 'Not Specified';
    }
    return candidateInformation;
  }

  _setCandidateSalaryOrRate(type, salaryOrRate) {
    let salaryOrRateText = '';
    if(salaryOrRate) {
        if(type == 'salary') {
            if(salaryOrRate.salaryType == 'Range') {
                salaryOrRateText = salaryOrRate.maxSalary + ' to ' + salaryOrRate.minSalary + " " + salaryOrRate.currency + " " + salaryOrRate.salaryDuration.replace(/_+/g, " ").toLowerCase();
            } else {
                salaryOrRateText = salaryOrRate.maxSalary + " " + salaryOrRate.currency + " " + salaryOrRate.salaryDuration.replace(/_+/g, " ").toLowerCase();
            }
        } else {
            if(salaryOrRate.rateType == 'Range') {
                salaryOrRateText = salaryOrRate.maxRate + ' to ' + salaryOrRate.minRate + " " + salaryOrRate.currency + " " + salaryOrRate.rateDuration.replace(/_+/g, " ").toLowerCase();
            } else {
                salaryOrRateText = salaryOrRate.maxRate + " " + salaryOrRate.currency + " " + salaryOrRate.rateDuration.replace(/_+/g, " ").toLowerCase();
            }
        }
    }
    // If value is null, undefined, or empty string, assign 'Not Specified'
    if (salaryOrRateText === null || salaryOrRateText === undefined || salaryOrRateText === '') {
        salaryOrRateText = 'Not Specified';
    }
    return salaryOrRateText;
  }
}
